export const SET_COMPANIES = 'SET_COMPANIES';
export const SET_COMPANIES_LOADING = 'SET_COMPANIES_LOADING';
export const SET_COMPANY_LOADING = 'SET_COMPANY_LOADING';
export const SET_COMPANY_FILTER = 'SET_COMPANY_FILTER';
export const SET_USER_FILTER = 'SET_USER_FILTER';
export const SET_COMPANY_DATA = 'SET_COMPANY_DATA';
export const RESET_COMPANY_USERS_FILTERS = 'RESET_COMPANY_USERS_FILTERS';
export const SET_COMPANY_DATA_ERROR = 'SET_COMPANY_DATA_ERROR';
